import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeLt from '@angular/common/locales/lt';
import localeNl from '@angular/common/locales/nl';
import localeSk from '@angular/common/locales/sk';

const SUPPORTED_LOCALE_DATA = [
  localeCs,
  localeDe,
  localeEn,
  localeFr,
  localeLt,
  localeNl,
  localeSk,
];

export function registerAppLocales(): void {
  SUPPORTED_LOCALE_DATA.forEach((locale) => registerLocaleData(locale));
}
